import { message as toast } from "antd";
import { Employee, Session } from "@/types/chat";
import { convertEmployeeToString, employeeToUid } from "@/utils/chat/message";
import { FocusSDK, JoyMeetingStatusEnum, isFocusEnv, getClientType } from "@/utils";
import { createMeeting, getJRTCToken } from "@/api/meeting";
import dayjs from "dayjs";
import { openUserSelectionModal } from "@/utils/modals";
import { mapGroupRosters } from "../../GroupUserSelector/common";
import { UserSelectionResult } from "@jd/focus-desktop-comps/lib/es/UserSelectionModal";
import bus from "@/utils/bus";
import cache from "@/utils/cache";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { NetType } from "@/components/Modals/ChangeNetModal";
import i18n from "i18next";
import config, { ConfigEnum } from "@/config/config";

// eslint-disable-next-line max-params
function handleOpenGroupSelector({
  groupRosters,
  userData,
  currentEmployee,
  selectedSession,
  onSelected,
  defaultSelected
}: {
  groupRosters: any;
  userData: any;
  currentEmployee: any;
  selectedSession: Session;
  onSelected?: (res: any) => void;
  defaultSelected?: any[];
}) {
  const groupMembers = mapGroupRosters(groupRosters, currentEmployee, { visible: true });
  openUserSelectionModal(
    {
      title: i18n.t("chat:select_current_group_member"),
      tabs: ["custom"],
      maxSelectedNum: 100,
      canSelectAll: true,
      resultUsers: defaultSelected || [],
      customTabs: [
        {
          canSelectAll: true,
          tabName: i18n.t("chat:current_group_member"),
          dataList: groupMembers
        }
      ],
      currentUser: employeeToUid(currentEmployee)
    },
    (data: UserSelectionResult, close: () => void) => {
      const { result } = data.data;
      const users = result.map((r) => {
        const tem = r.id.split(":");
        return {
          id: r.id,
          name: r.name,
          realName: r.name,
          userId: tem[0],
          teamId: tem[2],
          appId: tem[1],
          headImg: r.avatar as string,
          avatar: r.avatar,
          checked: true
        };
      });
      onSelected?.(users);
      close();
    },
    userData
  );
}

export function handleUserSelector({
  selectedSession,
  currentEmployee,
  newPublicResult,
  globalContext,
  onSelected,
  defaultSelected
}: {
  selectedSession: any;
  currentEmployee: any;
  newPublicResult: boolean;
  globalContext: {
    groupRosters: any;
    userData: any;
  };
  onSelected: (res: any) => void;
  defaultSelected?: any[];
}) {
  const { userData, groupRosters } = globalContext;
  handleOpenGroupSelector({
    selectedSession,
    currentEmployee,
    groupRosters,
    userData,
    defaultSelected,
    onSelected
  });
}
